import { ref, watch } from 'vue';

export type Theme = 'light' | 'dark' | 'system';

const STORAGE_KEY = 'moredeal.theme';

const stored = (
  typeof localStorage !== 'undefined' ? localStorage.getItem(STORAGE_KEY) : null
) as Theme | null;
const initial: Theme = stored ?? 'system';

const theme = ref<Theme>(initial);
const resolvedDark = ref<boolean>(false);

function resolve(t: Theme): boolean {
  if (t === 'dark') return true;
  if (t === 'light') return false;
  return typeof window !== 'undefined' && window.matchMedia('(prefers-color-scheme: dark)').matches;
}

function apply(dark: boolean) {
  if (typeof document === 'undefined') return;
  document.documentElement.classList.toggle('dark', dark);
  resolvedDark.value = dark;
}

apply(resolve(theme.value));

if (typeof window !== 'undefined') {
  const mq = window.matchMedia('(prefers-color-scheme: dark)');
  mq.addEventListener('change', () => {
    if (theme.value === 'system') apply(resolve('system'));
  });
}

watch(theme, (t) => {
  if (typeof localStorage !== 'undefined') localStorage.setItem(STORAGE_KEY, t);
  apply(resolve(t));
});

export function useTheme() {
  return {
    theme,
    isDark: resolvedDark,
    toggle: () => {
      theme.value = resolvedDark.value ? 'light' : 'dark';
    },
    set: (t: Theme) => {
      theme.value = t;
    },
  };
}
